import { render, staticRenderFns } from "./MobileNetworkBlock.vue?vue&type=template&id=0c398560&scoped=true&"
import script from "./MobileNetworkBlock.vue?vue&type=script&lang=js&"
export * from "./MobileNetworkBlock.vue?vue&type=script&lang=js&"
import style0 from "./MobileNetworkBlock.vue?vue&type=style&index=0&id=0c398560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c398560",
  null
  
)

export default component.exports